import React, {FC} from 'react';
import styled from 'styled-components';

import {
  CalendarsPanelId,
  EmlPanelId,
  MessagePanelId,
  ViewerPanelId,
} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {
  PopoverCoordinator,
  PopoverTransferProps,
} from '../../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {ellipsis} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {UserThemeConsumer} from '../../../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {buildContactDisplayName} from '../../../../../helpers/models/contactHelpers';
import {VisualParticipantModel} from '../../../../../models/api/visualParticipantModel';
import {ContactCardLocationsEnum} from '../../../../../store/panels/contacts/contactCard/contactCardPanelState';
import {ContactCardWrapperContainer} from '../../../../contactCard/contactCardWrapperContainer';

/*
 * Props.
 */

export interface CalendarInviteViewerParticipantTokenProps {
  panelId: CalendarsPanelId | ViewerPanelId | MessagePanelId | EmlPanelId;
  visualParticipant: VisualParticipantModel;
}

/*
 * Style.
 */

interface ParticipantStyleProps {
  $isOpen: boolean;
}
const StyledParticipantDiv = styled.div<ParticipantStyleProps>`
  padding: 3px 6px;
  margin-right: 6px;
  max-width: 300px;

  display: flex;
  align-items: center;

  background-color: ${(p) => (p.$isOpen ? p.theme.greys.shade40 : p.theme.greys.shade30)};
  border-radius: 4px;

  &:hover {
    background-color: ${(p) => p.theme.greys.shade40};
  }
`;

const StyledIconDiv = styled.div`
  flex-shrink: 0;
  margin-right: 4px;
`;

const StyledTextDiv = styled.div`
  flex: 1;
  ${ellipsis()};
`;

const StyledPopoverCoordinator = styled(PopoverCoordinator)`
  margin-bottom: 6px;
`;

/*
 * Component.
 */

export const CalendarInviteViewerParticipantToken: FC<CalendarInviteViewerParticipantTokenProps> = (
  props,
) => (
  <StyledPopoverCoordinator
    renderButton={(isOpen) => renderToken(isOpen, props.visualParticipant)}
    renderModal={(modalProps) => renderContactDropdown(modalProps, props.panelId, props.visualParticipant)}
  />
);

/*
 * Button.
 */

function renderToken(isOpen: boolean, visualParticipant: VisualParticipantModel) {
  return (
    <UserThemeConsumer>
      {(theme) => (
        <StyledParticipantDiv $isOpen={isOpen} data-searchable>
          {visualParticipant.isOrganizer && (
            <StyledIconDiv>
              <Icon name="crownSmall" color={theme.greys.shade60} />
            </StyledIconDiv>
          )}
          <StyledTextDiv>{buildContactDisplayName(visualParticipant)}</StyledTextDiv>
        </StyledParticipantDiv>
      )}
    </UserThemeConsumer>
  );
}

/*
 * Dropdown.
 */

function renderContactDropdown(
  modalProps: PopoverTransferProps,
  panelId: CalendarsPanelId | ViewerPanelId | MessagePanelId | EmlPanelId,
  visualParticipant: VisualParticipantModel,
) {
  return (
    <ContactCardWrapperContainer
      visualContact={visualParticipant}
      panelId={panelId}
      popoverProps={modalProps}
      location={ContactCardLocationsEnum.CALENDAR}
    />
  );
}
